import { useCopyToClipboard } from 'usehooks-ts';

import useToast from './use-toast.hook';

const useCopyWithToast = () => {
  const { toast } = useToast();

  const [, copy] = useCopyToClipboard();

  const handleCopyWithToast = (value: string) => {
    copy(value);
    toast('Copied to clipboard!');
  };

  return handleCopyWithToast;
};

export default useCopyWithToast;
